const CourseData = [
    {
        id: 1,
        title: "Artificial Intelligence",
        description: "A ONE YEAR Artificial Intelligence PROGRAM DESIGNED FOR ABSOLUTE BEGINNERS. GETTING PAKISTAN READY FOR THE NEW ERA OF COMPUTING ENABLED BY THE RISE OF AI.",
        img: require("../images/ai-min.jpg")
    },
    {
        id: 2,
        title: "Cloud Native Computing",
        description: "A ONE YEAR CNC PROGRAM DESIGNED FOR ABSOLUTE BEGINNERS. GETTING PAKISTAN READY FOR THE NEW ERA OF MICROSERVICES AND MULTI-CLOUD NATIVE COMPUTING.",
        img: require("../images/cloud-min.jpg")
    },
    {
        id: 3,
        title: "Blockchain Specialist",
        description: "A ONE YEAR BLOCKCHAIN PROGRAM DESIGNED FOR ABSOLUTE BEGINNERS GETTING PAKISTAN READY FOR THE NEW ERA OF BLOCKCHAIN, FINTECH AND SMART CONTRACTS.",
        img: require("../images/blockchain-development-min.jpg")
    },
    {
        id: 4,
        title: "Internet of Things ",
        description: " FIFTEEN MONTHS IOT AND AI PROGRAM DESIGNED FOR ABSOLUTE BEGINNERS GETTING PAKISTAN READY FOR THE NEW ERA OF INTERNET OF THINGS AND AI.",
        img: require("../images/ios.jpg")
    }

]

export default CourseData;